import { memo } from 'react';

import { Text } from '@/lib/v2/components';

interface EmptyScreenTableProps {
  image: JSX.Element;
  title?: string;
  descriptionNode?: JSX.Element;
  description?: string;
  actionText?: string;
  onClickAction?: () => void;
}

const EmptyScreenTable = ({
  image,
  title,
  description,
  descriptionNode,
  actionText,
  onClickAction,
}: EmptyScreenTableProps) => (
  <div className="mt-10 h-full w-full p-12">
    <div className="flex flex-col items-center justify-center gap-2 py-10">
      {image}
      <Text className="!font-medium text-emblue-tiles" variant="title-1">
        {title}
      </Text>
      <div>
        {descriptionNode}
        <Text className="text-center text-emblue-text" fontWeight="normal" variant="headline">
          {description}
          <Text
            link
            as="a"
            className="ml-1"
            color="primary"
            fontWeight="medium"
            variant="headline"
            onClick={onClickAction}
          >
            {actionText}
          </Text>
        </Text>
      </div>
    </div>
  </div>
);

export default memo(EmptyScreenTable);
